var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64869 0.857894C6.63101 0.787396 6.63038 0.7137 6.64685 0.64291C6.66332 0.57212 6.69642 0.506272 6.74341 0.45082C6.79039 0.395367 6.84992 0.351907 6.91704 0.324037C6.98417 0.296167 7.05697 0.284689 7.12942 0.290555C10.8941 0.593136 13.8546 3.74339 13.8546 7.58665C13.8546 11.63 10.5774 14.9072 6.534 14.9072C5.25205 14.9077 3.99246 14.5714 2.88134 13.932C1.77022 13.2926 0.846569 12.3726 0.202868 11.264C0.167042 11.2025 0.146044 11.1335 0.141542 11.0625C0.13704 10.9915 0.149158 10.9205 0.176933 10.855C0.204708 10.7895 0.247375 10.7314 0.301545 10.6852C0.355714 10.6391 0.419893 10.6063 0.488983 10.5893C1.46446 10.3495 2.65467 9.96459 3.73447 9.36675C4.81609 8.76708 5.75374 7.97159 6.27717 6.92476C7.3228 4.83415 7.04645 2.444 6.64869 0.857894Z",
    fill: "#262523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/darkMode.590037b4bd5084dc028e7f1644721ce4.svg";
export { ForwardRef as ReactComponent };